import React from "react"

export const Heading1 = ({
  children,
  className,
  ...props
}: React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLHeadingElement>,
  HTMLHeadingElement
>) => {
  return (
    <h1
      className={`font-inter text-size24 md:text-size48 font-semibold md:tracking-[-1px] ${className ? className : ""}`}
      {...props}
    >
      {children}
    </h1>
  )
}

export const Heading2 = ({
  children,
  className,
  ...props
}: React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLHeadingElement>,
  HTMLHeadingElement
>) => {
  return (
    <h2
      className={`font-inter text-size28 font-semibold tracking-[-0.02em] ${className ? className : ""}`}
      {...props}
    >
      {children}
    </h2>
  )
}

export const Heading3 = ({
  children,
  className,
  ...props
}: React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLHeadingElement>,
  HTMLHeadingElement
>) => {
  return (
    <h3
      className={`font-inter text-size24 font-semibold tracking-[-0.01em] ${className ? className : ""}`}
      {...props}
    >
      {children}
    </h3>
  )
}

export const Heading4 = ({
  children,
  className,
  ...props
}: React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLHeadingElement>,
  HTMLHeadingElement
>) => {
  return (
    <h4
      className={`font-inter text-size21 font-semibold tracking-[-0.01em] ${className ? className : ""}`}
      {...props}
    >
      {children}
    </h4>
  )
}
